import { zodResolver } from '@hookform/resolvers/zod';
import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
  UseFormReturn,
} from 'react-hook-form';
import { IImpactsOnStakeholdersFormValues } from './types';
import { ImpactsOnStakeholdersSchema } from './validators';

type ImpactsOnStakeholdersContext =
  UseFormReturn<IImpactsOnStakeholdersFormValues>;

type ImpactsOnStakeholdersFormSubmission = (
  formUtils: ImpactsOnStakeholdersContext
) => SubmitHandler<IImpactsOnStakeholdersFormValues>;

type ImpactsOnStakeholdersFormProviderType = {
  children: React.ReactNode;
  onSubmit?: ImpactsOnStakeholdersFormSubmission;
  initialValues?: IImpactsOnStakeholdersFormValues;
};

const useImpactsOnStakeholdersForm =
  useFormContext<IImpactsOnStakeholdersFormValues>;

const defaultFormValues: IImpactsOnStakeholdersFormValues = {
  isAllCompletedTh: false,
  isAllCompletedEn: false,
} as IImpactsOnStakeholdersFormValues;

const ImpactsOnStakeholdersFormProvider = (
  props: ImpactsOnStakeholdersFormProviderType
) => {
  const { children, onSubmit, initialValues } = props;
  const formContext = useForm<IImpactsOnStakeholdersFormValues>({
    mode: 'onChange',
    defaultValues: initialValues ?? defaultFormValues,
    resolver: zodResolver(ImpactsOnStakeholdersSchema),
  });

  return (
    <FormProvider {...formContext}>
      <form
        onSubmit={
          typeof onSubmit === 'function'
            ? formContext.handleSubmit(onSubmit(formContext))
            : undefined
        }
        style={{ width: '100%' }}
        noValidate
      >
        {children}
      </form>
    </FormProvider>
  );
};

export default ImpactsOnStakeholdersFormProvider;
export { useImpactsOnStakeholdersForm };
